import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import CustomizeOption from '../components/CustomizeOption'
import CustomizeModal from '../components/CustomizeModal';
import Checkbox from '../components/form/Checkbox';
import { pushEvent } from '../../../utilities/analytics';
import { CUSTOMIZE_WHAT_CLICKED, CUSTOMIZE_WHAT_SAVED } from '../../../constants/analyticEvents';
import { t } from '../../../utilities/translator';
import { toggleCustomizePanel } from '../customizeButtonSlice';
import { CUSTOMIZE } from '../../../constants/constants';
import { useGetWhatByCapacity } from '../../../hooks/mainFilter/useGetWhatByCapacity';

const What = ({
  onSave,
  selected,
  capacity,
}) => {
  const dispatch = useDispatch();
  const { activePanel } = useSelector(state => state.customize);
  const what = useGetWhatByCapacity(capacity);
  const [selectedFilters, setSelectedFilters] = useState(selected);

  useEffect(() => {
    setSelectedFilters(selected)
  }, [selected])

  const handleToggleCheckbox = (optionId) => {
    if (selectedFilters.includes(optionId)) {
      setSelectedFilters(prevState => prevState.filter(id => id !== optionId));
    } else {
      setSelectedFilters(prevState => [...prevState, optionId]);
    }
  }

  const allTypesChecked = selectedFilters.length === 0;

  const handleAllTypesCheck = () => {
    if (!allTypesChecked) {
      setSelectedFilters([]);
    }
  };

  const getOptionLabel = () => (
    what?.filter(whatItem => selectedFilters.includes(whatItem.id)).map(item => item.value).join(', ') || t('mainFilter.all_vacation')
  )

  const handleOptionClick = () => {
    dispatch(toggleCustomizePanel(CUSTOMIZE.WHAT))
    pushEvent(CUSTOMIZE_WHAT_CLICKED);
  }

  const handleSaveClick = () => {
    onSave(selectedFilters);
    dispatch(toggleCustomizePanel(null))
    pushEvent(CUSTOMIZE_WHAT_SAVED);
  }

  const handleClearClick = () => {
    setSelectedFilters([]);
    onSave([]);
    dispatch(toggleCustomizePanel(null))
  }

  const handleClose = () => {
    dispatch(toggleCustomizePanel(null))
    setSelectedFilters(selected);
  }

  return (
    <>
      <CustomizeOption
        label={t('mainFilter.What')}
        icon="ri-map-2-line"
        value={getOptionLabel()}
        onClick={handleOptionClick}
      />

      <CustomizeModal
        show={activePanel === CUSTOMIZE.WHAT}
        close={handleClose}
      >
        <CustomizeModal.Header close={handleClose} />
        <CustomizeModal.Body>
          <div className="text-xl font-semibold text-start">{t('mainFilter.What')}</div>
          <div className="list gap-3">
            <Checkbox
              key="all types"
              label={t('mainFilter.all_vacation')}
              checked={allTypesChecked}
              onChange={handleAllTypesCheck}
            />
            {what?.map(item => (
              <Checkbox
                key={item.id}
                label={item.value}
                onChange={() => handleToggleCheckbox(item.id)}
                checked={selectedFilters.includes(item.id)}
              />
            ))}
          </div>
        </CustomizeModal.Body>
        <CustomizeModal.Footer close={handleClose} onClear={handleClearClick} onSave={handleSaveClick} />
      </CustomizeModal>
    </>
  )
}

export default What
